import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  icon: {
    color: denim,
    width: 32,
    height: 32,
  },
  base: {
    marginHorizontal: indent,
    flexDirection: 'row',
    marginTop: indent * 0.75,
  },
  textContainer: {
    flex: 1,
    marginBottom: indent,
  },
  description: {
    marginTop: indent * 0.4,
  },
});
